import React, { Component } from 'react';

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

import ImprintIcon from '@material-ui/icons/Info';
import DataprivacyIcon from '@material-ui/icons/Security';


import ImprintDialog from './ImprintDialog';
import DataprivacyDialog from './DataprivacyDialog';
import CookieBanner from 'react-cookie-banner';
import Button from '@material-ui/core/Button';

class AppFooter extends Component {
  state = {
    imprintIsOpen: false,
    dataprivacyIsOpen: false,
  }

  toggleImprintDialog = () => {
    this.setState({
      imprintIsOpen: !this.state.imprintIsOpen,
    });
  };

  toggleDataprivacyDialog = () => {
    this.setState({
      dataprivacyIsOpen: !this.state.dataprivacyIsOpen,
    });
  };

  render() {
    const infoLink = React.createElement(
      'div',
      {},
      (
        <Button style={{ fontSize: '0.75rem', lineHeight: 1 }} onClick={this.toggleDataprivacyDialog} color="primary">Weitere Informationen</Button>
      ),

    );


    return (
      <footer style={{ background: '#6c3' }}>
        <div className="Content-wrapper">
          <BottomNavigation
            style={{ background: '#6c3' }}
            showLabels
          >
            <BottomNavigationAction style={{ background: '#6c3' }} onClick={this.toggleImprintDialog} label="Impressum" icon={<ImprintIcon style={{ fill: 'rgba(255,255,255,0.75)' }} />} />
            <BottomNavigationAction style={{ background: '#6c3' }} onClick={this.toggleDataprivacyDialog} label="Datenschutz" icon={<DataprivacyIcon style={{ fill: 'rgba(255,255,255,0.75)' }} />} />

          </BottomNavigation>
        </div>
        <ImprintDialog
          open={this.state.imprintIsOpen}
          onClose={this.toggleImprintDialog}
        />
        <DataprivacyDialog
          open={this.state.dataprivacyIsOpen}
          onClose={this.toggleDataprivacyDialog}
        />
        <CookieBanner
          styles={{
            banner: {
              height: 'auto',
              backgroundColor: 'rgba(52, 64, 81, 0.88)',
              fontSize: '0.75rem',
              fontWeight: 300,
              position: 'fixed',
              bottom: '0',
              zIndex: 0,

            },
            button: {
              border: '1px solid white',
              borderRadius: 4,
              width: 'auto',
              height: 'auto',
              right: 0,
              background: 'transparent',
              color: 'white',
              fontSize: '0.75rem',
              fontWeight: 300,
              opacity: 1,
              margin: '0 auto 0.5rem auto',
              position: 'relative',
            },
            message: {
              display: 'block',
              padding: '1rem 1rem 0 1rem ',
              fontSize: '0.75rem',
              lineHeight: 1.2,
              textAlign: 'center',

              color: 'white',
            },
            link: {
              textDecoration: 'none',
            },
            }}
          message="Cookies erleichtern die Bereitstellung unserer Dienste. Mit der Nutzung unserer Dienste erklären Sie sich damit einverstanden, dass wir Cookies verwenden."
          onAccept={() => {}}
          link={infoLink}
          cookie="user-has-accepted-cookies"
          dismissOnScroll={false}
          buttonMessage="Ok, danke"
        />
      </footer>
    );
  }
}


export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/layout/AppFooter.js